module.exports = __webpack_public_path__ + "media/images/mediator_symbolic-93c341433d8c2c58a8a8ba8e910bf502.jpg";